module.exports = __webpack_public_path__ + "static/img/cover3.64deb10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/cover3.png
// module id = 359V
// module chunks = 16